<template>
  <table  >
    <tr style="background-color: #d1d5db; text-align: center">
      <th style="width: 5%">STT</th>
      <th style="width: 40%">Tên khoản</th>
      <th style="width: 10%">SL</th>
      <th style="width: 20%">ST</th>
      <th style="width: 25%">Thành tiền</th>
    </tr>
    <tr v-for="(item, index) in listData" :key="index">
      <td>{{index+1}}</td>
      <td style="text-align: left">{{ item.name }}</td>
      <td >{{item.quantity}}</td>
      <td style="text-align: right">
        {{ item.price | formatCurrency}}
      </td>

      <td style="text-align: right">{{ item.sumMoney | formatCurrency}}</td>
    </tr>
    <tr>
      <td colspan="6" style="background-color: #d1d5db;">
        <table style="width: 100%;">
          <tr>
            <td style="text-align: center; font-weight: bold; width: 25%;">Tổng cộng</td>
            <td style="text-align: center; font-weight: bold; width: 25%;" v-if="tableData.beforeMoney >= 0">Nhà trường trả thừa <br/>(Tháng trước)</td>
            <td style="text-align: center; font-weight: bold; width: 25%;" v-if="tableData.beforeMoney < 0">Nhà trường trả thiếu <br/>(Tháng trước)</td>
            <td style="text-align: center; font-weight: bold; width: 25%;" v-if="tableData.spendMoney >= 0">Số tiền đã trả</td>
            <td style="text-align: center; font-weight: bold; width: 25%;" v-if="tableData.spendMoney < 0">Số tiền đã trả</td>
            <td style="text-align: center; font-weight: bold; width: 25%;" v-if="tableData.afterMoney <= 0">Nhân viên được nhận</td>
            <td style="text-align: center; font-weight: bold; width: 25%;" v-if="tableData.afterMoney > 0  && tableData.spendMoney !== 0">Nhà trường trả thừa</td>
            <td style="text-align: center; font-weight: bold; width: 25%;" v-if="tableData.afterMoney > 0  && tableData.spendMoney === 0">Nhân viên nộp thêm</td>
          </tr>
          <tr>
            <td style="text-align: right; width: 25%;"><b>{{ tableData.sumMoney | formatCurrencyNew }}</b></td>
            <td style="text-align: right; width: 25%;">{{ tableData.beforeMoney | formatCurrency }}</td>
            <td style="text-align: right; width: 25%;">{{ tableData.spendMoney | formatCurrency }}</td>
            <td style="text-align: right; width: 25%; color: red;">{{ tableData.afterMoney | formatCurrency }}</td>
          </tr>
          <tr>
            <td colspan="4" style="text-align: left; font-style: italic;">
              <i>Số tiền bằng chữ: {{ tableData.readMoney }}</i>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

</template>
<script>
export default {
  name: 'printNotNullTable',
  props: {
    tableData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      listData: [],
      spendMoney: 0
    }
  },
  mounted() {
    this.getListData()
  },
  methods:{
    getListData(){
      for (let i = 1; i <= 20; i++) {
        if (i <10){
          if (this.tableData[`nameK0${i}`] !== `Khoản ${i}` && this.tableData[`moneyK0${i}`] !== 0) {
            let employee = {};
            employee.name = this.tableData[`nameK0${i}`];
            employee.quantity = this.tableData[`quantityK0${i}`];
            employee.price = this.tableData[`priceK0${i}`];
            employee.sumMoney = this.tableData[`moneyK0${i}`];
            this.listData.push(employee);
          }
        }else {
          if (this.tableData[`nameK${i}`] !== `Khoản ${i}` && this.tableData[`moneyK${i}`] !== 0) {
            let employee = {};
            employee.name = this.tableData[`nameK${i}`];
            employee.quantity = this.tableData[`quantityK${i}`];
            employee.price = this.tableData[`priceK${i}`];
            employee.sumMoney = this.tableData[`moneyK${i}`];
            this.listData.push(employee);
          }
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

table th,
table td {
  border: 1px solid black;
  padding: 8px;
  text-align: center;
}
</style>